/* eslint-disable no-return-assign */
import { Grid, Typography } from "@mui/material";
import { translate } from "locale/formatter";
import { currency } from "utils/currencyFormatter";
import { formatDate, getFormattedTime } from "utils/dateUtils";

import ConfirmationDialog from "components/Dialog/ConfirmationDialog";

import { classes } from "./styled";

const PaymentBreakup = ({
  open,
  handleClosePopUp,
  refNumber,
  transactionTime = "",
  paymentType = "",
  totalAmount = 0,
}) => {
  const { containerText } = classes();

  const popupContent = (
    <>
      <Grid container className={containerText}>
        <Grid
          container
          className="flex px-2 "
          display={{ justifyContent: "space-between" }}
        >
          <Grid item>
            <b>{translate("total")}</b>
          </Grid>
          <Grid item>{currency(totalAmount)}</Grid>
        </Grid>
      </Grid>
    </>
  );

  const header = (
    <>
      <Grid
        container
        className="flex"
        display={{ justifyContent: "space-between", paddingBottom: ".5rem 0" }}
      >
        <Grid item>
          <Typography variant="subtitle1" fontSize="small">
            <b>
              {translate("ref_id")}: {refNumber || ""}
            </b>
          </Typography>
          <Typography variant="body2">
            {formatDate(transactionTime)} {getFormattedTime(transactionTime)}
          </Typography>
          <Typography variant="subtitle1" fontSize="small">
            {paymentType}
          </Typography>
        </Grid>
      </Grid>
      <hr />
    </>
  );

  return (
    <ConfirmationDialog
      open={open}
      header={header}
      content={popupContent}
      onCloseHandler={handleClosePopUp}
      primaryBtntext=""
      secondaryBtnText=""
    />
  );
};

export default PaymentBreakup;
